import {Order} from "../../graphql/graphql";

export const getOrderShopifyUrl = (order: Order) => {
    if (typeof order?.store?.shop === "undefined" || typeof order.shopifyOrderId === "undefined") {
        console.error("Couldn't get shopify order id from entity", order);
        return "";
    }
    return `https://${order.store.shop}/admin/orders/${order.shopifyOrderId}`;
};
